module.exports = __webpack_public_path__ + "img/missing_product.edabcc61.png";